import {
  ProfileHistoryInfo,
  ProfileHistoryResult,
} from "../../components/profile/ProfileHistoryWrapper";
import { useTypedSelector } from "../../hooks/useTypedRedux";
import { useGetTransactionsMutation } from "../../redux/api/transactionApi";
import HistoryItem from "../../ui/HistoryItem";
import { useSearchParams } from "react-router-dom";
import MobileWrapper from "../../components/profile/MobileWrapper";
import { Fragment } from "react";

const CashbackHistoryMobile = (): JSX.Element => {
  const [getTransactions] = useGetTransactionsMutation();
  const { transactionsCount, transactions } = useTypedSelector((state) => {
    return {
      transactionsCount: state.transactionSlice.cashbackOperationsCount,
      transactions: state.transactionSlice.cashbackOperations,
    };
  });

  const [rangesParams, setRangesParams] = useSearchParams();
  const callback = (props: { page?: number; action?: "add" }) =>
    getTransactions({
      range_start: Number(rangesParams.get("range_start")),
      range_end: Number(rangesParams.get("range_end")),
      type: "cashback",
      page: props.page || undefined,
      action: props.action || undefined,
    });
  return (
    <MobileWrapper
      title={"PROFILE_CASHBACK_HISTORY"}
      count={transactionsCount}
      childrenInfo={<ProfileHistoryInfo action={callback} />}
      childrenResult={
        <ProfileHistoryResult
          action={callback}
          isMobile={true}
          operationCount={transactionsCount}
          operationArray={transactions}
        >
          {transactions.map((item, index) => (
            <Fragment key={`operations-history-${index}-${item.createdAt}`}>
              <HistoryItem
                amount={`${item.amount.toFixed(2)}`}
                date={item.createdAt}
                type={item.type}
              />
            </Fragment>
          ))}
        </ProfileHistoryResult>
      }
    />
  );
};

export default CashbackHistoryMobile;
